
import { createSelector } from 'reselect'

const innerStateSelector = state => state.store

const dataSelector = createSelector(
   innerStateSelector,
   (state) => (state.storeData)
);
const fetchingSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetching)
);
const nextFetchingSelector = createSelector(
   innerStateSelector,
   (state) => (state.isNextFetching)
);
const isEmptySelector = createSelector(
   innerStateSelector,
   (state) => (state.isEmpty)
);
const isEmptyByFilterSelector = createSelector(
   innerStateSelector,
   (state) => (state.isEmptyByFilter)
);
const isFetchingByFilterSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingByFilter)
);
const isFetchingByIdSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingById)
);
const storeDetailsSelector = createSelector(
   innerStateSelector,
   (state) => (state.storeDetails)
);

const categoriesSelector = createSelector(
   innerStateSelector,
   (state) => (state.categories)
);

const successModalSelector = createSelector(
   innerStateSelector,
   state => (state.successModal)
)

const initedDataSelector = createSelector(
   innerStateSelector,
   state => state.inited
)

const ordersSelector = createSelector(
   innerStateSelector,
   state => state.ordersData.orders
)

const isFetchingOrdersSelector = createSelector(
   innerStateSelector,
   state => state.ordersData.isFetching
)

const isNewFetchingOrdersSelector = createSelector(
   innerStateSelector,
   state => state.ordersData.isNewFetching
)

const isEmptyOrdersSelector = createSelector(
   innerStateSelector,
   state => state.ordersData.isEmpty
)

const isFetchingByFilterOrdersSelector = createSelector(
   innerStateSelector,
   state => state.ordersData.isFetchingByFilter
)

const isEmptyByFilterOrdersSelector = createSelector(
   innerStateSelector,
   state => state.ordersData.isEmptyByFilter
)
const filtersSelector = createSelector(
   innerStateSelector,
   state => state.filters
);

const activeOrderRequestSelector = createSelector(
   innerStateSelector,
   state => state.activeOrderRequest
)

const activeOrderRequestPageLoadingSelector = createSelector(
   innerStateSelector,
   state => state.activeOrderRequestPageLoading
)

export {
   dataSelector,
   fetchingSelector,
   isEmptySelector,
   isEmptyByFilterSelector,
   isFetchingByFilterSelector,
   categoriesSelector,
   nextFetchingSelector,
   isFetchingByIdSelector,
   storeDetailsSelector,
   successModalSelector,
   initedDataSelector,
   ordersSelector,
   isFetchingOrdersSelector,
   isNewFetchingOrdersSelector,
   isEmptyOrdersSelector,
   isFetchingByFilterOrdersSelector,
   isEmptyByFilterOrdersSelector,
   filtersSelector,
   activeOrderRequestSelector,
   activeOrderRequestPageLoadingSelector,
}
